import React from 'react'
import ContentTranslations from 'components/ContentTranslations'

const ContentTranslationsPage = ({ id, itemId }) =>
	<ContentTranslations type='CATEGORY' id={itemId}/>

export default ContentTranslationsPage
